// Native forms handle search, variant changes and cart submission without JavaScript.
// This enhancement only changes the visible product image and closes mobile navigation.
document.addEventListener('click', (event) => {
  const link = event.target.closest('[data-mb-image]');
  if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
  const gallery = link.closest('[data-mb-gallery]');
  const main = gallery?.querySelector('.mb-main-image');
  if (!main) return;
  event.preventDefault();
  const image = link.querySelector('[data-mb-gallery-image]')?.content.querySelector('img');
  if (image) {
    // Copy Shopify's candidates before src so mobile stays responsive after a switch.
    for (const attribute of ['sizes', 'srcset', 'width', 'height', 'style']) {
      const value = image.getAttribute(attribute);
      if (value === null) main.removeAttribute(attribute);
      else main.setAttribute(attribute, value);
    }
    main.src = image.getAttribute('src');
  } else {
    main.removeAttribute('srcset');
    main.src = link.dataset.mbImage;
  }
  main.alt = link.dataset.mbAlt;
  gallery.querySelectorAll('[data-mb-image]').forEach((item) => item.removeAttribute('aria-current'));
  link.setAttribute('aria-current', 'true');
});
document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  const menu = document.querySelector('.mb-mobile-menu[open]');
  if (menu) { menu.open = false; menu.querySelector('summary').focus(); }
});

function martenbrownSetupRails(root = document) {
  root.querySelectorAll('[data-mb-rail]').forEach((rail) => {
    if (rail.dataset.mbReady) return;
    rail.dataset.mbReady = 'true';
    const grid = rail.querySelector('[data-mb-rail-grid]');
    const buttons = rail.querySelectorAll('[data-mb-rail-direction]');
    if (!grid) return;
    const update = () => {
      const end = grid.scrollWidth - grid.clientWidth;
      buttons.forEach((button) => {
        button.hidden = end < 2;
        button.disabled = Number(button.dataset.mbRailDirection) < 0 ? grid.scrollLeft < 2 : grid.scrollLeft >= end - 2;
      });
    };
    buttons.forEach((button) => button.addEventListener('click', () => {
      grid.scrollBy({left: Number(button.dataset.mbRailDirection) * Math.max(grid.clientWidth * .8, 228), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
    }));
    grid.addEventListener('scroll', update, {passive: true});
    const observer = new ResizeObserver(update);
    observer.observe(grid);
    rail.mbDisconnect = () => observer.disconnect();
    update();
  });
}
martenbrownSetupRails();
document.addEventListener('shopify:section:load', (event) => martenbrownSetupRails(event.target));
document.addEventListener('shopify:section:unload', (event) => event.target.querySelectorAll('[data-mb-rail]').forEach(rail => rail.mbDisconnect?.()));
